<div class="navbar">
    <!-- This is the hamburger menu that triggers below 370px -->
    <div class="mobile-version__drawer-container">
        <button mat-button class="menu-button" (click)="sidenav.toggle()">
            <mat-icon>{{ isMenuOpen ? "menu_open" : "menu" }}</mat-icon>
        </button>
        <mat-sidenav-container class="sidenav-container">
            <mat-sidenav #sidenav autoFocus="false" mode="over" [(opened)]="isMenuOpen" class="sidenav"
                (click)="onSidenavClick()">
                <div class="drawer__buttons">
                    <mat-accordion>
                        <p *ngIf="permissionsService.hasPermission('deps-module.cerere.list-all')" class="menu-link"
                            routerLink="/cereri" [class.menu-active]="'/cereri' === activeRoute"
                            (click)="setActiveRoute('/cereri')">
                            <img class="sidenav-request-btn" src="../../../../assets/icons/cereri.svg" alt="" />
                            <span>Cereri</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('deps-module.plati.list')" class="menu-link"
                            routerLink="/plati" [class.menu-active]="'/plati' === activeRoute"
                            (click)="setActiveRoute('/plati')">
                            <img class="sidenav-request-btn" src="../../../../assets/icons/plati.svg" alt="" />
                            <span>Plăți</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('deps-module.settings.sablon-cerere.list')"
                            class="menu-link" routerLink="/sabloane" [class.menu-active]="'/sabloane' === activeRoute"
                            (click)="setActiveRoute('/sabloane')">
                            <img class="sidenav-request-btn" src="../../../../assets/icons/sablon.svg" alt="" />
                            <span>Șabloane cereri</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('deps-module.programari.list')" class="menu-link"
                            routerLink="/programari" [class.menu-active]="'/programari' === activeRoute"
                            (click)="setActiveRoute('/programari')">
                            <img class="sidenav-request-btn" src="../../../../assets/icons/programari.svg" alt="" />
                            <span>Programări</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('deps-module.publicatii_casatorii.list')"
                            class="menu-link" routerLink="/publicatii-casatorii"
                            [class.menu-active]="'/publicatii-casatorii' === activeRoute"
                            (click)="setActiveRoute('/publicatii-casatorii')">
                            <img class="sidenav-request-btn" src="../../../../assets/icons/icon-publicatii.svg"
                                alt="" />
                            <span>Publicații Căsătorii</span>
                        </p>
                        <p class="menu-link" routerLink="/settings" [class.menu-active]="'/settings' === activeRoute"
                            (click)="setActiveRoute('/settings')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setari</span>
                        </p>

                        <ng-container *ngIf="permissionsService.hasPermission('deps-module.programari.list')">
                            <mat-expansion-panel *ngFor="let module of sidenavService.getModules()"
                                class="sidenav-accordion" (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false">
                                <mat-expansion-panel-header class="sidenav-accordion">
                                    <mat-panel-title class="sidenav-accordion">
                                        <div class="panel-title">
                                            <img class="panel-title-img"
                                                [src]="'../../../../assets/icons/programari.svg'" alt="" />
                                            <span>Programări {{ module.name }}</span>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <ng-container *ngFor="let locatieActiva of sidenavService.getLocatiiActive()">
                                    <p *ngIf="locatieActiva.id_modul === module.id" class="settings-option-menu"
                                        [class.menu-active]="('/programari-view/' + locatieActiva.id) === activeRoute"
                                        (click)="navigateToProgramariView(module.id, locatieActiva.id)">
                                        <img src="../../../../assets/icons/location-dot-solid.svg" alt="" />
                                        <span>{{ locatieActiva.name }}</span>
                                    </p>
                                </ng-container>
                            </mat-expansion-panel>
                        </ng-container>

                        <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="../../../../assets/icons/administrative.svg" alt="" />
                                        <span>Administrativ</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p routerLink="/admin-settings" class="settings-option-menu"
                                [class.menu-active]="'/admin-settings' === activeRoute"
                                (click)="setActiveRoute('/admin-settings')">
                                <img src="../../../../assets/icons/setari.svg" alt="" />
                                <span>Setari</span>
                            </p>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <div class="footer">
                        <div class="logout-button" (click)="logout()">
                            <img src="assets/icons/logout.svg" alt="Deconectare" />
                            <div class="logout-button--text">Deconectare</div>
                        </div>
                    </div>
                </div>
            </mat-sidenav>
            <mat-sidenav-content>
                <main>
                    <!-- <router-outlet></router-outlet> -->
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>





    <div class="username">{{ username }}</div>
    <div class="username__icon">
        <div class="username__icon--letters">{{ usernameLetters }}</div>
    </div>
    <!-- <div class="notification" [popover]="popTemplateNotifications" [adaptivePosition]="true"
        #notificationsPopover="bs-popover" placement="bottom" container="body" boundariesElement="scrollParent">
        <div class="notifications" [ngClass]="{ 'move-up': !userNotifications && !isLoading }">
            <mat-spinner color="primary" diameter="40" *ngIf="isLoading"></mat-spinner>
            <img src="assets/icons/icon-bell.svg" alt="Notificari" />
            <div class="notifications--chip" [ngClass]="{ 'hide-chip': isLoading }">
                <span *ngIf="!isLoading && userNotifications">{{ userNotifications }}</span>
            </div>
        </div>
    </div>

    <ng-template #popTemplateNotifications>
        <p class="title">Aveți {{ userNotifications }} notificări</p>
        <div class="notification-popup d-flex flex-column">
            <div class="notification-message-container">
                <button type="button"
                    class=" btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '1', name: 'Cereri'})">
                    <i class="fa-solid fa-envelope info"></i> {{notification['urbanism_modified']}} Cereri necesită
                    atenția dvs.
                </button>

                <button type="button"
                    class="btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '2', name: 'Mesaje interne'})">
                    <i class="fa-solid fa-triangle-exclamation warning"></i> {{notification['urbanism_messages']}}
                    Mesaje interne pentru dvs.
                </button>
            </div>
        </div>
    </ng-template> -->
</div>